import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Box, Button } from '@mui/material'
import Translations from 'src/@core/layouts/components/Translations'

import { numberFormatAsked } from 'src/@core/utils/number-format-asked'
import { useRouter } from 'next/router'
import GradientBox from 'src/views/reports/gradient-box'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import { CardCargaData } from 'src/@types'

interface Props {
  landId: number
  data: CardCargaData
}

export default function CardCarga({ landId, data }: Props) {
  const router = useRouter()
  const colors = ['#FF0404', '#FAFF0A', '#25B522', '#FAFF0A', '#FF0404']

  return (
    <Card
      className='rodeos-card'
      sx={{
        minWidth: '250px',
        height: '495px',
        alignItems: 'center',
        borderRadius: '20px',
        backgroundColor: 'white !important',
      }}
    >
      <CardContent
        className='card-medio'
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <Typography
            sx={{ fontSize: '18px', fontWeight: '700', color: 'black', textAlign: 'center', mb: 4 }}
            className='cards-title'
          >
            <Translations text={'Stock'} />
          </Typography>
          <Typography
            sx={{
              color: '#222',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 400,
              letterSpacing: '-0.28px',
              mb: 2
            }}
          >
            {data.cycle?.replace('_', '/')}
          </Typography>
          <Box
            sx={{
              mt: '24px',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <GradientBox colors={colors} tall='15px' />
            <Box sx={{ width: '90%', justifyContent: 'flex-start', display: 'flex' }}>
              <ArrowDropUpIcon
                sx={{ verticalAlign: 'middle', color: 'black', marginLeft: `${(data.load * 0.9) / 2}%` }}
                fontSize='large'
              />
            </Box>
          </Box>
          <Typography
            sx={{ fontSize: '40px', fontWeight: 700, color: 'black', textAlign: 'center' }}
          >{`${data.load} %`}</Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '15px',
            backgroundColor: 'rgba(25, 118, 210, 0.20)',
            mt: '24px',
            height: '40px',
            paddingLeft: '20px',
            paddingRight: '20px'
          }}
        >
          <Typography sx={{ color: 'black', fontSize: 'clamp(10px, 14px, 18px)', textAlign: 'left', ml: 3 }}>
            <Translations text={'EV current stock'} />
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            <Typography sx={{ color: 'black', fontWeight: '600', fontSize: '18px' }}>
              {numberFormatAsked(data.actualEv)}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '15px',
            backgroundColor: 'rgba(25, 118, 210, 0.20)',
            mt: '24px',
            height: '40px',
            paddingLeft: '20px',
            paddingRight: '20px'
          }}
        >
          <Typography sx={{ color: 'black', fontSize: 'clamp(10px, 14px, 18px)', textAlign: 'left', ml: 3 }}>
            <Translations text={'Potential production'} />
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            {
              <Typography sx={{ color: 'black', fontWeight: '600', fontSize: '18px' }}>
                {numberFormatAsked(data.potentialProduction)}
              </Typography>
            }
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '15px',
            backgroundColor: 'rgba(25, 118, 210, 0.20)',
            mt: '24px',
            height: '40px',
            paddingLeft: '20px',
            paddingRight: '20px'
          }}
        >
          <Typography sx={{ color: 'black', fontSize: 'clamp(10px, 14px, 18px)', textAlign: 'left', ml: 3 }}>
            <Translations text={'Potential EV'} />
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            <Typography sx={{ color: 'black', fontWeight: '600', fontSize: '18px' }}>
              {numberFormatAsked(data.potentialEv)}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', w: '100%', alignItems: 'center', mt: 'auto', marginTop: '10px' }}>
          <Button
            variant='outlined'
            sx={{
              color: '#213D36',
              width: '123px',
              padding: '8px, 12px, 8px, 12px',
              fontSize: '16px',
              fontWeight: 700,
              borderRadius: '30px',
              border: '3px solid #213D36',
              mt: 'auto'
            }}
            onClick={() => router.push(`/lands/details/rodeos/${landId}`)}
          >
            <Translations text={'See more'} />
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}
